<template>
  <div class="d-flex justify-content-end align-items-end">
    {{ $t("common.showing") }}

    <div class="bg-white mx-2 cs-dropdown-select dropdown">
      <button
        @click="state.isVisible = !state.isVisible"
        type="button"
        aria-expanded="false"
        aria-haspopup="true"
        class="btn dropdown-toggle"
      >
        {{ state.selectedOption.label }}
      </button>
      <div
        :class="{ 'd-block': state.isVisible }"
        class="dropdown-menu"
        style=""
      >
        <div
          v-for="(item, index) in options || defaultOptions"
          @click="(action(item), selecteActive(item))"
          :key="index"
          role="menuitem"
          href="#"
          target="_self"
          class="dropdown-item"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <div
      v-if="
        pagination.total > 0 &&
        pagination.per_page.label != $t('common.all_entries')
      "
    >
      <span class="d-inline-block me-2">{{ $t("common.entries") }}</span>
      {{ $t("common.showing") }} {{ pagination.from }}
      {{ $t("common.showing_to") }} {{ pagination.to }}
      {{ $t("common.showing_of") }} {{ pagination.total }}
    </div>
    <div
      v-if="
        pagination.total > 0 &&
        pagination.per_page.label == $t('common.all_entries')
      "
    >
      {{ $t("common.showing") }} 1 {{ $t("common.showing_to") }}
      {{ pagination.to }} {{ $t("common.showing_of") }} {{ pagination.total }}
    </div>
  </div>
</template>

<script>
import { reactive, computed } from "vue"
import { useI18n } from "vue-i18n"

export default {
  name: "PerPageSelector",
  props: {
    pagination: {
      type: Object
    },
    options: {
      type: Array,
      deep: true,
      default: null
    },
    action: {
      type: Function
    }
  },
  setup() {
    const { t } = useI18n()

    const defaultOptions = computed(() => [
      {
        label: "25",
        value: 25
      },
      {
        label: "50",
        value: 50
      },
      {
        label: "100",
        value: 100
      },
      {
        label: t("common.all_entries"),
        value: 75
      }
    ])

    const state = reactive({
      isVisible: false,
      selectedOption: {
        label: "25",
        value: 25
      }
    })

    const selecteActive = (item) => {
      state.selectedOption = item
      state.isVisible = false
    }

    return {
      state,
      selecteActive,
      defaultOptions
    }
  }
}
</script>
